import * as React from 'react';
import { SimpleModal } from '../SimpleModal/SimpleModal';
import './UnsavedChangesModal.scss';

interface Props {
  isOpen: boolean;
  message: string;
  onKeepEditing: () => void;
  onDiscard: () => void;
}

export const UnsavedChangesModal = ({ isOpen, message, onKeepEditing, onDiscard }: Props) => (
  <SimpleModal
    isOpen={isOpen}
    title="Discard unsaved changes?"
    showFooter={false}
    isBodyBold={false}
    customClass="unsavedChangesModal"
    dialogStyle={{ maxWidth: 480 }}
    onCloseClick={onKeepEditing}
    onBackdropClick={onKeepEditing}
  >
    <div className="unsavedChangesModal__content">
      <div className="unsavedChangesModal__notice">
        <span aria-hidden="true">!</span>
        <div>
          <strong>Unsaved changes</strong>
          <p>{message}</p>
        </div>
      </div>
      <div className="unsavedChangesModal__actions">
        <button type="button" onClick={onKeepEditing}>
          Keep editing
        </button>
        <button type="button" className="is-danger" onClick={onDiscard}>
          Discard changes
        </button>
      </div>
    </div>
  </SimpleModal>
);
